import React from "react";
import CRUDAdmin from "../../components/admin/CRUDAdmin";

export default function Services() {
  return (
    <CRUDAdmin
      title="Services"
      subtitle="Service verticals displayed on the public website."
      endpoint="/admin/services"
      testIdPrefix="srv"
      defaults={{ active: true, order: 100, icon: "Award" }}
      columns={[
        { title: "Title", render: r => <><div className="serif text-lg">{r.title}</div><div className="text-navy-900/50 text-xs">{r.tagline}</div></> },
        { title: "Slug", key: "slug" },
        { title: "Icon", key: "icon" },
        { title: "Order", key: "order" },
      ]}
      fields={[
        { name: "title", label: "Title" },
        { name: "slug", label: "Slug" },
        { name: "tagline", label: "Tagline" },
        { name: "icon", label: "Lucide Icon Name (e.g. Heart, Briefcase)" },
        { name: "order", label: "Order", type: "number" },
        { name: "description", label: "Description", type: "textarea", full: true },
        { name: "image_url", label: "Image", type: "media", full: true },
        { name: "active", label: "Active", type: "checkbox" },
      ]}
    />
  );
}
